<template>
  <svg :class="{'active':state}" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 22 22">
    <circle class="outer" cx="11" cy="11" r="10"/>
    <circle class="inner" cx="11" cy="11" r="6"/>
  </svg>
</template>

<script>
export default {
  name: "RadioSvg",
  props: {
    title: {
      default: 'RadioSvg',
      type: String,
    },
    fill: {
      default: 'currentColor',
      type: String,
    },
    size: {
      type: Number,
      default: 14,
    },
    state: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
svg {
  width: 20px;
  height: 20px;
  transform: translateY(5px);
  margin-right: 5px;

  .outer {
    fill: none;
    stroke: var(--dark-blue);
    stroke-width: 2px;
    stroke-miterlimit: 10;
  }

  .inner {
    fill: var(--green);
    transform: scale(0);
    transform-origin: center;
    transition: transform .15s;
  }

  &.active {
    .inner {
      transform: scale(1);
    }
  }
}
</style>
